import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import Select from "Components/select/Select";
import PropTypes from "prop-types";
import InputVerify from "Components/inputVerify/InputVerify";
import Checkbox from "Components/checkbox/Checkbox";
import PasswordGenerator from "Components/PasswordGenerator";
import RadioButton from "Components/radiobutton/RadioButton";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import _ from "lodash";
import SupportContactBox from "Components/supportContactBox/SupportContactBox";
import cx from "classnames";
import s from "./orderDetails.scss";
import QboxmailApi from "@/qboxmailApi";
import isEmail from "validator/lib/isEmail";
import WarningBanner from "Components/warningBanner/WarningBanner";

const api = new QboxmailApi({ useCookie: true });

const ContextTypes = {
  router: PropTypes.object,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

export default class OrderDetailsStep extends React.Component {
  state = {
    setNewWHMCSCredentials: false,
    isPromocodeValid: false,
    isVerifyingPromocode: false,
  };

  toggleWHMCSCredentials = () => {
    this.setState({ setNewWHMCSCredentials: !this.state.setNewWHMCSCredentials });
  };

  validateExtraContact = () => {
    const hasFirstName = this.props.formData.contact_firstname && this.props.formData.contact_firstname !== "";
    const hasLastName = this.props.formData.contact_lastname && this.props.formData.contact_lastname !== "";
    const hasEmail = this.props.formData.contact_email && this.props.formData.contact_email !== "";

    const firstName = this.props.formData.contact_firstname;
    const lastName = this.props.formData.contact_lastname;
    const email = this.props.formData.contact_email;

    // if all fields are empty, is ok
    if (!hasFirstName && !hasLastName && !hasEmail) return true;

    let errors = {};

    if (!hasFirstName) errors.contact_firstname = t("errors.not_empty");
    if (!hasLastName) errors.contact_lastname = t("errors.not_empty");
    if (!hasEmail) errors.contact_email = t("errors.not_empty");

    if (hasEmail) {
      if (!isEmail(email)) errors.contact_email = t("errors.invalid_email");
    }

    this.props.setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  goToNextStep = async () => {
    this.props.resetFormErrors();

    if (!this.validateExtraContact()) return;

    let errors = this.validate(this.props.formData);

    if (this.props.formData.promocode && this.props.formData.promocode !== "") {
      const isValid = await this.verifyPromocode();
      if (!isValid) return;
    }

    if (Object.keys(errors).length > 0) {
      this.props.setFormErrors(errors);
    } else {
      this.props.setFormErrors({});
      this.props.goToStep(5);
    }
  };

  goBack = () => {
    this.props.goToStep(3);
  };

  validate = (data) => {
    let errors = {};
    let requireds = ["email_address", "password2", "password2_confirmation"];

    if (this.state.setNewWHMCSCredentials) {
      requireds.forEach((field) => {
        if (!data[field]) errors[field] = t("input.error.empity");
      });

      if (data.password2 !== data.password2_confirmation) {
        errors.password2_confirmation = t("input.error.pwdMatch");
      }
    }

    return errors;
  };

  fillPasswordFields = (generatedPassword) => {
    this.props.setFormFieldValue({
      password2: generatedPassword,
      password2_confirmation: generatedPassword,
    });
  };

  verifyPromocode = async () => {
    let isValid = false;

    this.setState({ isVerifyingPromocode: true, isPromocodeValid: false });
    const resp = await api
      .verifyPromocode(this.props.formData.promocode, this.props.formData.billing_cycle)
      .catch((err) => null);

    if (resp) {
      this.setState({ isPromocodeValid: true });
      isValid = true;
      this.props.setFormErrors({
        promocode: null,
      });
    } else {
      this.props.setFormErrors({
        promocode: "Non valido",
      });
      isValid = false;
    }

    this.setState({ isVerifyingPromocode: false });
    return isValid;
  };

  render() {
    const {
      formData: { billing_cycle, payment_method },
      customer,
      formData,
      formErrors,
      setFormFieldValue,
    } = this.props;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    return (
      <div className="orderPage">
        {this.props.stepper}

        {!isMediaMobile() && !isMediaSM() && !isMediaMD() && <SupportContactBox className="supportBox" />}

        <div className={cx("sectionTitle", "titleFP")}>{t("order.add.title.step4")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("order.add.desc.step4")}</div>
          </div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              <RadioButton
                className="inputFull2"
                grouplabel={t("input.label.select.payment.frequency")}
                children={[
                  {
                    value: "monthly",
                    label: t("input.label.billing.monthly"),
                    description: t("input.hint.billing.monthly"),
                  },

                  {
                    value: "annually",
                    label: t("input.label.billing.annually"),
                    description: t("input.hint.billing.annually"),
                    disabled: formData.customer_type === "reseller",
                  },
                ]}
                name="billing_cycle"
                value={billing_cycle}
                onChange={setFormFieldValue}
              />

              <RadioButton
                className="inputFull2"
                grouplabel={t("input.label.select.payment.method")}
                children={[
                  {
                    value: "stripe",
                    label: t("radiobtn.label.payment.stripe"),
                    description: t("radiobtn.desc.payment.creditCard"),
                  },

                  {
                    value: "lcwsoftpaypalbillingagreements",
                    label: t("radiobtn.label.payment.lcwsoftpaypalbillingagreements"),
                    description: t("radiobtn.desc.payment.paypal.auto"),
                  },

                  {
                    value: "paypal",
                    label: t("radiobtn.label.payment.paypal"),
                    description: t("radiobtn.desc.payment.paypal"),
                  },

                  {
                    value: "banktransfer",
                    label: t("radiobtn.label.payment.bankTransfer"),
                    description: t("radiobtn.desc.payment.bankTransfer"),
                  },
                ]}
                name="payment_method"
                value={payment_method}
                onChange={setFormFieldValue}
              />

              <InputVerify
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.promocode")}
                placeholder={t("input.placeholder.promocode")}
                name="promocode"
                value={formData.promocode}
                errors={formErrors.promocode}
                onChange={setFormFieldValue}
                loading={this.state.isVerifyingPromocode}
                isVerified={this.state.isPromocodeValid}
                onClick={this.verifyPromocode}
              />

              <div className={cx("inputFull2", s.wrapInfoBilling)}>
                <div className={s.labelInfoBilling}>{t("input.label.billing.system")}</div>

                <TranslatedString subs={{ userName: customer.email_address }}>infoMsg.billing.system</TranslatedString>
              </div>

              <Checkbox
                className="inputFull2"
                label={t("input.label.billing.system.otherCredentials")}
                checked={this.state.setNewWHMCSCredentials}
                onChange={this.toggleWHMCSCredentials}
              />

              {this.state.setNewWHMCSCredentials && (
                <>
                  <div className="inputFull2">
                    <WarningBanner color="blue" info msg={t("infoMsg.billing")} />
                  </div>

                  <div className="inputFull2">
                    <Input
                      className={cx("inputFull2", "inputAddMargin")}
                      type="email"
                      name="email_address"
                      label={t("input.label.billing.email")}
                      placeholder={t("input.placeholder.email")}
                      value={formData.email_address}
                      errors={formErrors.email_address}
                      onChange={setFormFieldValue}
                      required
                    />

                    <Input
                      className="inputFull2"
                      name="password2"
                      label={t("input.label.billing.password")}
                      type="password"
                      value={formData.password2}
                      errors={formErrors.password2}
                      onChange={setFormFieldValue}
                      autocomplete={false}
                      required
                    />

                    <Input
                      className="inputFull2"
                      name="password2_confirmation"
                      label={t("input.label.billing.password.confirm")}
                      type="password"
                      value={formData.password2_confirmation}
                      errors={formErrors.password2_confirmation}
                      onChange={setFormFieldValue}
                      autocomplete={false}
                      required
                    />

                    <PasswordGenerator onNewPassword={this.fillPasswordFields} className="inputFull2" />
                  </div>
                </>
              )}

              <div className="mt-6 inputFull2">
                <div className={cx(s.labelInfoBilling, "mb-3")}>{t("input.label.billing.extraContact")}</div>
                <Input
                  className="mb-4 inputFull2"
                  name="contact_firstname"
                  label={t("input.label.billing.extraContactFirstname")}
                  value={formData.contact_firstname}
                  errors={formErrors.contact_firstname}
                  onChange={setFormFieldValue}
                />

                <Input
                  className="mb-4 inputFull2"
                  name="contact_lastname"
                  label={t("input.label.billing.extraContactLastname")}
                  value={formData.contact_lastname}
                  errors={formErrors.contact_lastname}
                  onChange={setFormFieldValue}
                />

                <Input
                  className={cx("inputFull2", "inputAddMargin")}
                  type="email"
                  name="contact_email"
                  label={t("input.label.billing.extraContactEmail")}
                  placeholder={t("input.placeholder.email")}
                  value={formData.contact_email}
                  errors={formErrors.contact_email}
                  onChange={setFormFieldValue}
                />
              </div>
            </div>

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" onClick={this.goToNextStep} loading={this.state.isVerifyingPromocode}>
                button.continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OrderDetailsStep.contextTypes = ContextTypes;
